export const GET_CENTERS: string = 'src/pages/centers/GET_CENTERS';
export const GET_CENTERS_SUCCESS: string =
  'src/pages/centers/GET_CENTERS__SUCCESS';
export const GET_CENTERS_FAILED: string =
  'src/pages/centers/GET_CENTERS__FAILED';

export const GET_CENTERS_WITH_ID: string =
  'src/pages/centers/GET_CENTER_WITH_ID';
export const GET_CENTERS_WITH_ID_SUCCESS: string =
  'src/pages/centers/GET_CENTER_WITH_ID_SUCCESS';
export const GET_CENTERS_WITH_ID_FAILED: string =
  'src/pages/centers/GET_CENTER_WITH_ID_FAILED';

export const UPDATE_CENTERS: string = 'src/pages/centers/UPDATE_CENTER';
export const UPDATE_CENTERS_SUCCESS: string =
  'src/pages/centers/UPDATE_CENTER_SUCCESS';
export const UPDATE_CENTERS_FAILED: string =
  'src/pages/centers/UPDATE_CENTER_FAILED';

export const CREATE_CENTERS: string = 'src/pages/centers/CREATE_CENTERS';
export const CREATE_CENTERS_SUCCESS: string =
  'src/pages/centers/CREATE_CENTERS_SUCCESS';
export const CREATE_CENTERS_FAILED: string =
  'src/pages/centers/CREATE_CENTERS_FAILED';

export const GET_USERS_BY_CENTERS_ID: string =
  'src/pages/centers/GET_USERS_BY_CENTERS_ID';
export const GET_USERS_BY_CENTERS_ID_SUCCESS: string =
  'src/pages/centers/GET_USERS_BY_CENTERS_ID_SUCCESS';
export const GET_USERS_BY_CENTERS_ID_FAILED: string =
  'src/pages/centers/GET_USERS_BY_CENTERS_ID_FAILED';

export const GET_USERS_BE_ADMIN_CENTER: string =
  'src/pages/centers/GET_USERS_BE_ADMIN_CENTER';
export const GET_USERS_BE_ADMIN_CENTER_SUCCESS: string =
  'src/pages/centers/GET_USERS_BE_ADMIN_CENTER_SUCCESS';
export const GET_USERS_BE_ADMIN_CENTER_FAILED: string =
  'src/pages/centers/GET_USERS_BE_ADMIN_CENTER_FAILED';

export const UPDATE_CENTER_ADMIN: string =
  'src/pages/centers/UPDATE_CENTER_ADMIN';
export const UPDATE_CENTER_ADMIN_SUCCESS: string =
  'src/pages/centers/UPDATE_CENTER_ADMIN_SUCCESS';
export const UPDATE_CENTER_ADMIN_FAILED: string =
  'src/pages/centers/UPDATE_CENTER_ADMIN_FAILED';

export const GET_ALL_CENTERS_REPORT: string =
  'src/pages/centers/GET_ALL_CENTERS_REPORT';
export const GET_ALL_CENTERS_REPORT_SUCCESS: string =
  'src/pages/centers/GET_ALL_CENTERS_REPORT_SUCCESS';
export const GET_ALL_CENTERS_REPORT_FAILED: string =
  'src/pages/centers/GET_ALL_CENTERS_REPORT_FAILED';

export const GET_ALL_SUPERVISORS: string =
  'src/pages/centers/GET_ALL_SUPERVISORS';
export const GET_ALL_SUPERVISORS_SUCCESS: string =
  'src/pages/centers/GET_ALL_SUPERVISORS_SUCCESS';
export const GET_ALL_SUPERVISORS_FAILED: string =
  'src/pages/centers/GET_ALL_SUPERVISORS_FAILED';

export const UPDATE_CENTER_STATUS: string =
  'src/pages/centers/UPDATE_CENTER_STATUS';
export const UPDATE_CENTER_STATUS_SUCCESS: string =
  'src/pages/centers/UPDATE_CENTER_STATUS_SUCCESS';
export const UPDATE_CENTER_STATUS_FAILED: string =
  'src/pages/centers/UPDATE_CENTER_STATUS_FAILED';

export const GET_CENTERS_ACTIVE_COUNT: string =
  'src/pages/centers/GET_CENTERS_ACTIVE_COUNT';
export const GET_CENTERS_ACTIVE_COUNT_SUCCESS: string =
  'src/pages/centers/GET_CENTERS_ACTIVE_COUNT_SUCCESS';
export const GET_CENTERS_ACTIVE_COUNT_FAILED: string =
  'src/pages/centers/GET_CENTERS_ACTIVE_COUNT_FAILED';

export const GET_CENTERS_DEACTIVE_COUNT: string =
  'src/pages/centers/GET_CENTERS_DEACTIVE_COUNT';
export const GET_CENTERS_DEACTIVE_COUNT_SUCCESS: string =
  'src/pages/centers/GET_CENTERS_DEACTIVE_COUNT_SUCCESS';
export const GET_CENTERS_DEACTIVE_COUNT_FAILED: string =
  'src/pages/centers/GET_CENTERS_DEACTIVE_COUNT_FAILED';

export const GET_CENTERS_STATISTICS: string =
  'src/pages/centers/GET_CENTERS_STATISTICS';
export const GET_CENTERS_STATISTICS_SUCCESS: string =
  'src/pages/centers/GET_CENTERS_STATISTICS_SUCCESS';
export const GET_CENTERS_STATISTICS_FAILED: string =
  'src/pages/centers/GET_CENTERS_STATISTICS_FAILED';

export const GET_CENTERS_STATISTICS_WITH_ID: string =
  'src/pages/centers/GET_CENTERS_STATISTICS_WITH_ID';
export const GET_CENTERS_STATISTICS_WITH_ID_SUCCESS: string =
  'src/pages/centers/GET_CENTERS_STATISTICS_WITH_ID_SUCCESS';
export const GET_CENTERS_STATISTICS_WITH_ID_FAILED: string =
  'src/pages/centers/GET_CENTERS_STATISTICS_WITH_ID_FAILED';
